import { decodeJwt } from "jose";
import type { cookies } from "next/headers";
import type { NextRequest } from "next/server";
import { getClientCookie } from "./cookies";

type CookieStore = Awaited<ReturnType<typeof cookies>>;

export const isGuestToken = (authToken: string) => {
  try {
    const token = decodeJwt(authToken);
    if (token.type === "GUEST") {
      return true;
    }
    return false;
  } catch {
    return false;
  }
};

export const getClientAuthToken = () => {
  const token = getClientCookie("token");

  if (!token || typeof token !== "string") {
    return null;
  }

  return token;
};

export const getServerAuthToken = (request: NextRequest): string | null => {
  return request.cookies.get("token")?.value ?? null;
};

export const setServerAuthToken = (
  token: string,
  options: { expires?: Date; cookieStore: CookieStore },
) => {
  options.cookieStore.set("token", token, {
    expires: options.expires,
    path: "/",
  });
};

export const deleteServerAuthToken = (cookieStore: CookieStore) => {
  cookieStore.delete("token");
};
